import { SessionContext } from "@/context/SessionContext";
import { Button, Group, Modal, Stack } from "@mantine/core";
import {
  MediaControlBar,
  MediaController,
  MediaFullscreenButton,
  MediaMuteButton,
  MediaPlaybackRateButton,
  MediaPlayButton,
  MediaSeekBackwardButton,
  MediaSeekForwardButton,
  MediaTimeDisplay,
  MediaTimeRange,
  MediaVolumeRange,
} from "media-chrome/react";
import { useContext } from "react";
import ReactPlayer from "react-player";

type VideoPlayerProps = {
  videoPath: string;
  width: string;
};

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoPath, width }) => {
  return (
    <MediaController
      style={{
        width: width,
        aspectRatio: "16/9",
        borderRadius: "20px",
      }}
    >
      {/* Keep your original props here */}
      <ReactPlayer
        slot="media"
        src={videoPath}
        controls={false}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "20px",
        }}
      />
      <MediaControlBar
        style={{
          borderRadius: "20px",
        }}
      >
        <MediaPlayButton
          style={{
            borderRadius: "20px",
          }}
        />
        <MediaSeekBackwardButton seekOffset={10} />
        <MediaSeekForwardButton seekOffset={10} />
        <MediaTimeRange />
        <MediaTimeDisplay showDuration />
        <MediaMuteButton />
        <MediaVolumeRange />
        <MediaPlaybackRateButton />
        <MediaFullscreenButton
          style={{
            borderRadius: "20px",
          }}
        />
      </MediaControlBar>
    </MediaController>
  );
};

type VideoModalProps = {
  title?: string;
  videoPath: string;
  isOpen: boolean;
  setShowModal: (show: boolean) => void;
};

const VideoModal: React.FC<VideoModalProps> = ({
  title,
  videoPath,
  isOpen,
  setShowModal,
}) => {
  const handleClose = () => {
    setShowModal(false);
  };

  const session = useContext(SessionContext);
  if (session === undefined) {
    throw new Error("VideoModal must be a child of SessionContext.");
  }

  if (!isOpen) return null;

  return (
    <Modal
      opened={isOpen}
      withCloseButton
      radius={25}
      size={"90%"}
      onClose={handleClose}
      title={title || "A video"}
    >
      <Stack align={"center"} gap="md" h="100%">
        <VideoPlayer videoPath={videoPath} width={"100%"} />

        {/* Download button */}
        <Group justify="flex-end" w="100%">
          <Button
            component="a"
            href={videoPath}
            download
            variant="light"
          >
            Download video
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default VideoModal;
